module.exports = __webpack_public_path__ + "static/media/Barovia1.c2bcbc61.jpg";